export default __webpack_public_path__ + "static/media/delete-red.60bc1412.svg";